export const UNSUPPORTED_NODE_TYPE = '__UNSUPPORTED__NODE__';
export const UNSUPPORTED_MARK_TYPE = '__UNSUPPORTED__DECORATION__';
